<template>
  <div class="flex-col org-main">
    <div class="div-top">
      <i class="iconfont iconbuilding-outline"
        style="font-size: 0.875rem; color: #c52a1a"></i>
      <div class="org-name">{{ $t("orgName") }}</div>
      <div id="org-list-filter"
        class="filter"
        v-if="showFilter"
        @click="showSearch">
        <span> {{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>
      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '80%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"
          ref="orgSelect"></search-panel>
      </van-popup>
    </div>

    <div class="cont-list">
      <van-list v-if="showFilter"
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <org-item v-for="item in list"
          v-bind:key="item.id"
          :data="item"
          :show-chk="isEdit"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe" />
      </van-list>
      <van-list v-if="!showFilter"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <org-item v-for="item in list"
          v-bind:key="item.historyId"
          :data="item"
          :show-chk="isEdit"
          @cancel="cancelMark"
          :disable-swipe="disableSwipe" />
      </van-list>
    </div>
  </div>
</template>

<script>
import SearchPanel from "@components/common/SearchPanel";
import OrgItem from "./OrgItem";
import common from "@common/common";
import webService from "@network/webService";
import _ from 'lodash';

export default {
  name: "",
  data () {
    return {
      disableSwipe: true,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 0,
      showSearchPanel: false,
      searchPanelType: common.searchTypeEnum.org,
      oldSearchModel: {
        Search: "",
        SearchType: common.relationshipSearchTypeEnum.PEOrganization,
        InvestmentPreferenceIds: [],
        IndustryIds: [],
        InvestmentTypeIds: [],
        OrgStage: [],
        OrgIndustry: [],
      },
      showFilter: false,
      isHistory: false,
    };
  },
  props: {
    pageType: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OrgItem,
    SearchPanel,
  },
  created () {
    //this.showFilter = this.pageType != common.searchTypeEnum.orgHistory;
  },
  mounted () {
    this.showFilter = this.pageType != common.searchTypeEnum.orgHistory;
    this.disableSwipe = this.pageType != common.searchTypeEnum.orgCollect;
  },
  methods: {
    reset () {
      console.log("reset");
      this.list = [];
      this.loading = false;
      this.finished = false;
    },
    onRefresh () {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 0;
      this.list = [];
      this.onLoad();
    },
    onLoad () {
      console.log(this.currentPage);
      if (this.currentPage == 0) {
        this.list = [];
      }
      this.requestPageData();
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document.getElementById('org-list-filter').classList.add('has-filter');
      } else {
        document.getElementById('org-list-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.list = [];
      if (this.searchPanelType == common.searchTypeEnum.org) {
        this.oldSearchModel.SearchType =
          common.relationshipSearchTypeEnum.PEOrganization;
        this.oldSearchModel.InvestmentPreferenceIds =
          searchParams.InvestmentPreferenceIds;
        this.oldSearchModel.IndustryIds = searchParams.IndustryIds;
        this.oldSearchModel.InvestmentTypeIds =
          searchParams.InvestmentTypeIds;
        this.oldSearchModel.OrgStage = searchParams.OrgStage;
        this.oldSearchModel.OrgIndustry = searchParams.OrgIndustry;
      }
      this.showSearchPanel = false;
      console.log(searchParams);
      //web 数据请求
      this.requestPageData();
    },
    getData (searchModel) {
      if (searchModel.isHistory) {
        this.isHistory = true;
      }
      if (searchModel.hasFilter) {
        document.getElementById('org-list-filter').classList.add('has-filter');
      } else {
        document.getElementById('org-list-filter').classList.remove('has-filter');
      }
      this.currentPage = 0;
      this.list = [];
      if (!searchModel) {
        searchModel = {
          PageSize: 100,
          Page: 0,
          SearchType:
            common.relationshipSearchTypeEnum.PEOrganization,
        };
      } else if (this.searchPanelType == common.searchTypeEnum.org) {
        this.oldSearchModel = searchModel;
      }
      //web 数据请求
      this.requestPageData(true);
    },
    requestPageData (isFirst) {
      let searchModel = {
        PageSize: 20,
        Page: this.currentPage,
        SearchType: this.oldSearchModel.SearchType,
        Search: this.oldSearchModel.Search,
        InvestmentPreferenceIds:
          this.oldSearchModel.InvestmentPreferenceIds,
        IndustryIds: this.oldSearchModel.IndustryIds,
        InvestmentTypeIds: this.oldSearchModel.InvestmentTypeIds,
        FavoriteType: common.favoriteTypeEnum.Organization,
        OrgStage: this.oldSearchModel.OrgStage,
        OrgIndustry: this.oldSearchModel.OrgIndustry,
      };
      //console.log(searchModel); 
      if (this.pageType == common.searchTypeEnum.orgCollect) {
        webService.getFavoriteRelationships(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData_collect(this, res.data);
        });
      } else if (this.pageType == common.searchTypeEnum.orgHistory) {
        webService.searchOrgHistoryList(searchModel).then((res) => {
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
        });
      } else {
        webService.newSearchOrgList(searchModel).then((res) => {
          console.log('newSearchOrgList')
          if (isFirst) {
            this.currentPage = 0;
            this.list = [];
          }
          common.procssData(this, res.data);
          this.list = _.uniqBy(this.list, 'id');
        });
      }
    },
    showSearch () {
      this.showSearchPanel = true;
      this.$nextTick(function () {
        if (this.isHistory) {
          this.$refs.orgSelect.resetPanel();
        }
        this.$refs.orgSelect.initSelectItem(true);
      });
    },
    selectAll () {
      this.list.forEach((element) => {
        element.checked = true;
      });
    },
    cancelSelected () {
      this.list.forEach((element) => {
        element.checked = false;
      });
    },
    deleteItem () {
      common.batchDeleteMarked(this);
    },
    cancelMark (id) {
      common.cancelMark(this, id);
    },
    changeSearchValue (value) {
      this.oldSearchModel.Search = value;
    },
  },
};
</script>

<style lang='less' scoped>
.org-main {
  border-top: 1px solid #dedede;
  height: 99%;
}
.div-top {
  display: flex;
  padding: 0.375rem 0.625rem;
  align-items: center;
  height: 2.875rem;
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
    margin-left: 0.375rem;
  }
  .filter {
    text-align: right;
    flex: 1;
    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}
.cont-list {
  overflow: auto;
  flex: 1;
  height: 100%;
}

/deep/ .van-tabs__line {
  background-color: #c52a1a;
}
// /deep/ .van-list {
//   height: 100%;
// }
</style>


// WEBPACK FOOTER //
// src/components/content/org/OrgList.vue